<!-- go-app-customers-virtual-table.component.html -->
<div class="table-container allow-scroll-bar" #tableContainer (scroll)="onScroll()" (dragstart)="handleContainerDragStart($event)">
  <!-- Header Row -->
  <ng-container *ngTemplateOutlet="rowTemplate; context: { row: null, header: true }"></ng-container>
  <div [style.height.px]="paddingTop" *ngIf="visibleRows.length > 0"></div>
  <!-- Data Rows -->
  <ng-container *ngFor="let row of visibleRows; let i = index; trackBy: trackByFn">
    <ng-container *ngTemplateOutlet="rowTemplate; context: { row: row, rowIndex: i }"></ng-container>
  </ng-container>
  <!-- Loading Row -->
  <ng-container *ngFor="let row of skeletonRows; trackBy: trackByFn">
    <ng-container *ngTemplateOutlet="rowTemplate; context: { header: false }"></ng-container>
  </ng-container>
  <div [style.height.px]="paddingBottom" *ngIf="visibleRows.length > 0"></div>
</div>
<div class="no-search-image-wrapper" *ngIf="!loadingMore && visibleRows.length === 0 && noDataText">
  <div class="image-wrapper">
    <img src="assets/imgs/search-illustration.svg"
        alt="No search result"
        priority fill/>
    <div class="label">
      {{ noDataText }}
    </div>
  </div>
</div>

<ng-template #cellTemplate let-row="row" let-column="column" let-colIndex="colIndex" let-header="header">
  <div class="cell" [style.width.px]="column?.width"
    [style.left.px]="column?.sticky === 'left' ? stickyLeftOffsets[colIndex] : null"
    [style.right.px]="column?.sticky === 'right' ? stickyRightOffsets[colIndex] : null"
    [class.sticky-left]="column?.sticky === 'left'" [class.sticky-right]="column?.sticky === 'right'"
    [class.sortable]="column?.sortable && header"
    [draggable]="header"
    (dragstart)="onDragStart($event, colIndex)"
    (dragover)="onDragOver($event, colIndex)"
    (dragend)="onDragEnd($event)"
    (drop)="onDrop($event, colIndex)"
    [class.drag-over]="dragOverColumnIndex === colIndex"
    (click)="header && handleSort(column, $event)">
    <div class="column-header-container" *ngIf="header">
      <span class="column-header-text">{{ column?.name }}</span>
      <div class="column-header-sort-icon" *ngIf="column?.sortable">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M6 2.25L8.25 5.25H3.75L6 2.25Z"
            [attr.fill]="sorted?.field === column?.field && !sorted?.asc ? '#000' : '#979797'" />
          <path fill-rule="evenodd" clip-rule="evenodd" d="M6 9.75L8.25 6.75H3.75L6 9.75Z"
            [attr.fill]="sorted?.field === column?.field && sorted?.asc ? '#000' : '#979797'" />
        </svg>
      </div>
    </div>
    <div class="column-header-resize-handle" (mousedown)="onResizeStart($event, colIndex)"
      (touchstart)="onResizeStart($event, colIndex)" *ngIf="header"></div>

    <ng-container *ngIf="!header && _cellTemplate">
      <ng-container
        *ngTemplateOutlet="cellTemplate; context: { row: row, column: column, colIndex: colIndex }"></ng-container>
    </ng-container>
    <ng-container *ngIf="!header && row && !_cellTemplate">
      <ng-container *ngIf="column.avatarField || column.avatarFallbackField">
        <ion-avatar class="column-avatar">
          <ng-container *ngIf="column.avatarField && (row[column.avatarField]?.then ? (row[column.avatarField] | async) : row[column.avatarField]) as avatarUrl; else fallbackAvatar">
            <ion-img [src]="avatarUrl" [alt]="row[column.field] || ''" ></ion-img>
          </ng-container>
        </ion-avatar>
      </ng-container>
      <ng-template #fallbackAvatar>
        <ion-avatar
          class="column-avatar">
          <div class="avatar-initial">
            {{ column.avatarFallbackField ? row[column.avatarFallbackField] : '' }}
          </div>
      </ion-avatar>
      </ng-template>
      <ng-container *ngIf="column.field && (row[column.field]?.then ? (row[column.field] | async) : row[column.field]) as value; else fallbackValue">
        <span class="column-value-text" [title]="value || ''">
          <span [innerHTML]="row.__highlighted?.[column.field] || value || ''"></span>
        </span>
      </ng-container>
      <ng-template #fallbackValue>
        <span class="column-value-text"></span>
      </ng-template>
    </ng-container>

    <ion-skeleton-text class="column-value-text skeleton-text-animated" *ngIf="!header && !row"></ion-skeleton-text>
  </div>
</ng-template>
<ng-template #rowTemplate let-row="row" let-header="header" let-rowIndex="rowIndex">
  <div class="row" [class.header-row]="header" [class.data-row]="!header && !!row" (click)="handleRowClicked(row, $event)"
    [class.clickable]="rowClickable" [class.highlighted]="row && highlightedRows?.has(row[primaryKeyField])" [class.selected]="row && selectedRows?.has(row[primaryKeyField])"
    [attr.draggable]="rowDraggable && !!row && !header ? true : null"
    [attr.data-row-index]="!header && row ? rowIndex : null">
    <div class="cell checkbox-cell sticky-left" [style.width.px]="checkboxColumnWidth" *ngIf="showCheckbox">
      <ion-checkbox aria-label="Select all" *ngIf="header && showSelectAll" (ionChange)="handleSelectAll($event.detail.checked)"
        [checked]="selectAll" [indeterminate]="selectAll === null"></ion-checkbox>
      <ion-checkbox (ionChange)="handleRowSelected(row, $event.detail.checked)" *ngIf="row && !header"
        [checked]="selectedRows.has(row[primaryKeyField])"></ion-checkbox>
      <ion-checkbox disabled *ngIf="!row && !header"></ion-checkbox>
    </div>
    <ng-container *ngFor="let column of columns; let colIndex = index; trackBy: trackById">
      <ng-container
        *ngTemplateOutlet="cellTemplate; context: { row: row, column: column, colIndex: colIndex, header: header }"></ng-container>
    </ng-container>
    <div class="cell flex-filler" *ngIf="fillerNeeded"></div>
    <div *ngIf="showAction" class="cell action-cell sticky-right" [style.width.px]="actionColumnWidth">
      <div class="column-header-container" *ngIf="header">
        <span class="column-header-text">Action</span>
      </div>
      <ng-container *ngIf="row && !header && actionCellTemplate">
        <ng-container *ngTemplateOutlet="actionCellTemplate; context: { $implicit: row }"></ng-container>
      </ng-container>
      <ion-skeleton-text class="column-value-text skeleton-text-animated" *ngIf="!row && !header"></ion-skeleton-text>
    </div>
  </div>
</ng-template>
